import axios from 'axios';

export const CONFIG = {
  appVersion: '2.0.0',
  baseURL: (import.meta as any)?.env?.VITE_API_BASE_URL || 'https://gestpvapi.montanstahl.com',
  timeout: 10000,
  tokenKey: 'authToken',
};

export const api = axios.create({
  baseURL: CONFIG.baseURL,
  timeout: CONFIG.timeout,
  headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
});

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(CONFIG.tokenKey);
  if (t) {
    cfg.headers = cfg.headers || {};
    (cfg.headers as any).Authorization = `Bearer ${t}`;
  }
  return cfg;
});

export function loginRequest(username: string, password: string) {
  return axios.post(
    `${CONFIG.baseURL}/auth/login`,
    `AppVersion=${encodeURIComponent(CONFIG.appVersion)}`,
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded', jwtusername: username, jwtpassword: password }, timeout: CONFIG.timeout }
  );
}
